import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PackageOpen } from 'lucide-react';
export function EmptyApplicationList(param) {
    let { title } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex min-h-[200px] flex-col items-center justify-center gap-4 p-8",
        children: [
            /*#__PURE__*/ _jsx(PackageOpen, {
                className: "h-16 w-16 text-muted-foreground"
            }),
            /*#__PURE__*/ _jsx("p", {
                className: "text-center text-base text-muted-foreground",
                children: title !== null && title !== void 0 ? title : 'There are currently no applications added. Please start with creating a new project'
            })
        ]
    });
}
